export default "__VITE_ASSET__61f6a42a__"